var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4267,21.6699c-.2753,0-.4985-.2232-.4985-.4985V.6084c0-.2753.2232-.4985.4985-.4985h2.4925c.2753,0,.4985.2232.4985.4985v20.563c0,.2753-.2232.4985-.4985.4985h-2.4925Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2184,14.6278v-3.8349h-3.8805c-.2346,0-.4247-.1902-.4247-.4248v-4.2903c0-.2346.1901-.4248.4247-.4248h3.8805V1.8182c0-.1892.2288-.284.3626-.1502l6.4048,6.4048c.0829.0829.0829.2174,0,.3004l-6.4048,6.4048c-.1338.1338-.3626.039-.3626-.1502Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1274,16.1267v3.8348c0,.1893-.2288.284-.3626.1502L.3601,13.7069c-.0829-.0829-.0829-.2174,0-.3003l6.4048-6.4048c.1338-.1338.3626-.039.3626.1502v3.8349h3.8805c.2346,0,.4248.1902.4248.4248v4.2903c0,.2346-.1902.4248-.4248.4248h-3.8805Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryExit);
export default __webpack_public_path__ + "static/media/entry-exit.5a6da31eb8cedcfb6d5c1ba7a5b928a9.svg";
export { ForwardRef as ReactComponent };